import React from "react";
import {
  Checkbox,
  Dialog,
  FlatButton,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TextField,
} from "material-ui";
import DialogTitle from "../Shared/DialogTitle";
import { FormattedMessage, injectIntl } from "react-intl";
import ActionSearch from "material-ui/svg-icons/action/search";
import { addGroup, deleteGroup, updateGroup } from "./actions";
import { checkJapanese } from "../../lib";

const tdStyle = {
  padding: "8px",
  borderRight: "1px solid #b8b8b8",
  textAlign: "center",
  whiteSpace: "pre-wrap",
  overflow: "visible",
  color: "#657285",
  wordBreak: 'break-all'
};

class AddGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      emailAddressBook: [],
      isAllSelected: false,
      selectedIds: [],
      hasError: false,
      errorMessage: "",
      hasGroupNameError: false,
      groupNameAlreadyUsed: false
    };
  }

  componentDidMount() {
    if (
      this.props.isEdit &&
      this.props.selectedGroup &&
      this.props.selectedGroup.id
    ) {
      this.setState(
        {
          name: this.props.selectedGroup.name,
          selectedIds: this.props.selectedGroup.addresses.map((a) =>
            parseInt(a)
          ),
        },
        () => {
          this.isAllSelected();
        }
      );
    }
    this.setState({
      emailAddressBook: this.props.emailAddressBook.map((e) => {
        e.visible = true;
        return e;
      }),
    });
  }

  resetError = () => {
    this.setState({ hasError: false, errorMessage: "" });
  };

  handleSubmit = () => {
    const isGroupNameAlreadyUsed = this.props.groups.find(g => g.name === this.state.name);
    if(this.props.isEdit) {
      if(this.props.selectedGroup.name !== this.state.name && isGroupNameAlreadyUsed) {
        this.setState({ groupNameAlreadyUsed: true });
        return;
      }
    } else if(isGroupNameAlreadyUsed) {
      this.setState({ groupNameAlreadyUsed: true });
      return;
    }


    if(this.state.name) {
      if (this.props.isEdit) {
        this.handleUpdate(this.state.selectedIds);
      } else {
        addGroup({ name: this.state.name, ids: this.state.selectedIds })
          .then((r) => this.props.onSuccess())
          .catch((e) => {
            console.log("Error: ", e);
            this.setState({ hasError: true, errorMessage: checkJapanese() ? "サーバでエラーが発生しました。グループを追加できません。" : "Unable to add the group, server error occured."});
          });
      }
    } else {
      this.setState({ hasGroupNameError: true });
    }
  };

  handleUpdate = (ids) => {
    if (this.props.selectedGroup && this.props.selectedGroup.id) {
      updateGroup({
        name: this.state.name,
        id: this.props.selectedGroup.id,
        ids,
      })
        .then((r) => {
          this.props.onSuccess();
        })
        .catch((e) => {
          this.setState({ hasError: true, errorMessage: checkJapanese() ? "サーバでエラーが発生しました。グループを更新できません" : "Unable to update the group, server error occurred."});
          console.log("Err: ", e);
        });
    }
  };

  handleDelete = () => {
    const confirmation = window.confirm(
      checkJapanese() ? "グループを削除してよろしいですか？" : "Are you sure you want to delete the group?"
    );
    if (confirmation) {
      if (this.props.selectedGroup && this.props.selectedGroup.id) {
        deleteGroup(this.props.selectedGroup.id)
          .then((r) => this.props.onSuccess())
          .catch((e) => {
            this.setState({ hasError: true, errorMessage: checkJapanese() ? "サーバでエラーが発生しました。アドレスを削除できません。" : "Unable to delete the address, server error occurred."});
            console.log("Err: ", e);
          });
      }
    }
  };

  isAllSelected() {
    let selectedIds = this.state.selectedIds;
    let address = this.state.emailAddressBook.map((a) => a.id);
    let isAllSelected =
      selectedIds.length == address.length &&
      selectedIds.every((element, index) => {
        return address.includes(element);
      }) &&
      this.state.emailAddressBook.length !== 0;
    this.setState({ isAllSelected });
  }

  handleAddressSelect = (id) => {
    this.resetError();
    let selectedIds = this.state.selectedIds;
    selectedIds.includes(id)
      ? (selectedIds = selectedIds.filter((i) => i !== id))
      : selectedIds.push(id);
    this.setState({ selectedIds }, () => {
      this.isAllSelected();
    });
  };

  handleAllAdressSelect = () => {
    this.resetError()
    let value = !this.state.isAllSelected;
    let selectedIds = this.state.emailAddressBook
      .filter((a) => a.visible)
      .map((a) => a.id);
    this.setState({
      selectedIds: value ? selectedIds : [],
      isAllSelected: value,
    });
  };

  handleUserSearch = (e) => {
    let emailAddressBook = this.state.emailAddressBook;
    emailAddressBook = emailAddressBook.map((a) => {
      if (e && e.target && e.target.value === "") {
        a.visible = true;
        return a;
      } else if (a.name && e && e.target && e.target.value) {
        a.visible = a.name.toLowerCase().includes(e.target.value.toLowerCase());
      }
      return a;
    });
    this.setState({ emailAddressBook });
  };

  render() {
    const actions = [
      <FlatButton
        label={<FormattedMessage id="emailAddressBook.cancel" />}
        labelStyle={{ color: "#858585" }}
        onClick={this.props.handleClose}
        style={{ borderRadius: "5px" }}
      />,
      <FlatButton
        backgroundColor="#60d1bd"
        hoverColor="#60d1bd"
        label={<FormattedMessage id="emailAddressBook.save" />}
        labelStyle={{ color: "#fff" }}
        onClick={this.handleSubmit}
        style={{ borderRadius: "5px" }}
      />,
    ];

    if(this.props.isEdit) {
      actions.unshift(<FlatButton
        backgroundColor="#d75654"
        hoverColor="#d75654"
        label={<FormattedMessage id="emailAddressBook.delete" />}
        labelStyle={{ color: "#fff" }}
        onClick={this.handleDelete}
        style={{ borderRadius: "5px" }}
      />)
    }

    return (
      <Dialog
        modal={false}
        title={
          <DialogTitle
            heading={<FormattedMessage id="emailAddressBook.editGroup" />}
            handleClose={this.props.handleClose}
          />
        }
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: "550px", width: "96%" }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        actions={actions}
        actionsContainerStyle={{
          display: "flex",
          justifyContent: "space-around",
          backgroundColor: "rgb(241, 241, 241)",
          padding: "12px 28px 15px",
        }}
        className="popup-modal"
        bodyClassName="popup-modal-body"
      >
        <div
          style={{
            backgroundColor: "rgb(241, 241, 241)",
            padding: "20px 30px",
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ flex: "0 0 23%", paddingTop: "20px" }}>
              <FormattedMessage id="emailAddressBook.groupName" />
            </div>

            <div style={{ flex: "1 0 auto", marginLeft: "10px", display: "flex", flexDirection: "column" }}>
              <TextField
                fullWidth={true}
                value={this.state.name}
                inputStyle={{
                  color: "#657285"
                }}
                placeholder={this.props.intl.formatMessage({ id: "emailAddressBook.groupNamePlaceholder" })}
                onChange={(e) => {
                  this.resetError();
                  this.setState({ name: e.target.value, hasGroupNameError: false,groupNameAlreadyUsed: false, groupNameAlreadyUsed: false })
                }}
              />
              {this.state.hasGroupNameError && <div><label className="width-auto" style={{ fontSize: '14px', color: 'red', marginBottom: '6px' }}><FormattedMessage id="emailAddressBook.addGroupNameError" /></label></div>}
              {this.state.groupNameAlreadyUsed && <label className="width-auto" style={{ fontSize: '14px', color: 'red', marginBottom: '6px' }}><FormattedMessage id="emailAddressBook.groupNameAlreadyUsed" /></label>}
              <div
                style={{
                  border: "1px solid #6B7c93",
                  position: "relative",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  minWidth: "250px",
                  marginTop: "10px",
                  background: "#fff",
                }}
              >
                <input
                  className="email-search"
                  style={{
                    border: "none",
                    width: this.props.view !== 'mobile' ? '82%' : '100%',
                    height: "90%",
                    padding: "0 5px",
                    color: "#657285"
                  }}
                  placeholder={this.props.intl.formatMessage({ id: "emailAddressBook.searchUserName" })}
                  onChange={(e) => this.handleUserSearch(e)}
                />
                <ActionSearch
                  style={{
                    position: "absolute",
                    right: "0",
                    marginRight: "5px",
                    fill: "#6B7c93",
                  }}
                />
              </div>
            </div>
          </div>

          <Table
            selectable={false}
            selectedColor="black"
            // height={"70vh"}
            style={{ border: "1px solid #b8b8b8", marginTop: "8px" }}
          >
            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
              <TableRow
                style={{
                  border: "1px solid #b8b8b8",
                  backgroundColor: "#6B7c93",
                  color: "#fff",
                }}
              >
                <TableRowColumn style={tdStyle} className="flex-center">
                  <Checkbox
                    iconStyle={{
                      fill: "#fff",
                    }}
                    style={{
                      width: "auto",
                    }}
                    inputStyle={{
                      width: "100%",
                    }}
                    checked={this.state.isAllSelected}
                    onCheck={this.handleAllAdressSelect}
                  />
                </TableRowColumn>
                <TableRowColumn colSpan={3} style={{...tdStyle, color: '#fff'}}>
                  {<FormattedMessage id="emailAddressBook.name" />}
                </TableRowColumn>
              </TableRow>
              {(this.state.emailAddressBook.length == 0 || this.state.emailAddressBook.every(a => !a.visible)) && (
                <TableRow
                  selected={false}
                  className="dark-row"
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={4} style={tdStyle}>
                    <p style={{ color: '#979797' }} className="room-name">
                      {
                        this.state.emailAddressBook.length == 0  
                        ? <FormattedMessage id="emailAddressBook.noUsers" /> 
                        : <FormattedMessage id="emailAddressBook.noResultFound" />
                      }
                    </p>
                  </TableRowColumn>
                </TableRow>
              )}

              {this.state.emailAddressBook.map((address, index) => {
                if (address.visible) {
                  return (
                    <TableRow
                      key={index}
                      selected={false}
                      className={index % 2 == 0 ? "dark-row" : "light-row"}
                      style={{
                        backgroundColor: "#f2f3f6",
                        borderBottom: "1px solid #b8b8b8",
                      }}
                    >
                      <TableRowColumn style={tdStyle} className="flex-center">
                        <Checkbox
                          iconStyle={{
                            fill: "#657285",
                          }}
                          style={{
                            width: "auto",
                          }}
                          inputStyle={{
                            width: "100%",
                          }}
                          checked={this.state.selectedIds.includes(address.id)}
                          onCheck={() => this.handleAddressSelect(address.id)}
                        />
                      </TableRowColumn>
                      <TableRowColumn colSpan={3} style={tdStyle}>
                        {address.name}
                      </TableRowColumn>
                    </TableRow>
                  );
                }
              })}
            </TableBody>
          </Table>
        </div>
      </Dialog>
    );
  }
}

export default injectIntl(AddGroup);



// WEBPACK FOOTER //
// src/components/EmailAddressBook/AddGroup.js